"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'shortcuts.table.shortcut': 'Scorciatoia',
    'shortcuts.table.description': 'Descrizione',
};
